module.exports = __webpack_public_path__ + "Frame408-78e38465.webp";